export const paginationEventType = {
    change: 'change'
};
export class PaginationEvent extends Event {
    constructor(type, { detail, originalTarget }) {
        super(type, { cancelable: true });
        this.detail = detail;
        this.originalTarget = originalTarget;
    }
}
//# sourceMappingURL=pagination-event.js.map